/* eslint-disable jsx-a11y/label-has-associated-control */
import { type ReactNode, useState, useCallback } from 'react';
import DatePicker, { type ReactDatePickerProps } from 'react-datepicker';
import cn from 'classnames';
import 'react-datepicker/dist/react-datepicker.css';
import type { TFieldComponentProps } from './types';

export interface IDatePickerProps
  extends
    TFieldComponentProps<Date | null | undefined>,
    Omit<ReactDatePickerProps, 'form' | 'name' | 'value' | 'selected' | 'onChange' | 'onBlur'> {
  max?: Date;
  label?: ReactNode;
  outerClassName?: string;
}

const CDatePicker = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  max,
  label,
  className,
  dateFormat,
  outerClassName,
  ...props
}: IDatePickerProps) => {
  const { name } = field;
  // react-datepicker reads `value` only as a string (the input text), never the field's Date.
  const { value: fieldValue, ...fieldProps } = field;
  const [value, setValue] = useState(fieldValue);
  const handleOnChange = useCallback(
    // Not a range picker (no `selectsRange`): the date is a Date or null.
    (date: Date | null) => {
      setValue(date);
      setFieldValue(name, date);
    },
    [setFieldValue, name],
  );
  const getClassNameForInput =
    touched[field.name] && errors[field.name] ? 'error-input default-input' : 'default-input';
  return (
    <div className={cn('field-wrapper', outerClassName)}>
      <label className="label-when-focused-input">{label}</label>
      <DatePicker
        {...fieldProps}
        {...props}
        selected={value}
        onChange={handleOnChange}
        autoComplete="none"
        className={cn(getClassNameForInput, className)}
        dateFormat={dateFormat || 'dd.MM.yyyy'}
      />
      {touched[name] && errors[name] && <div className="error-text">{errors[name]}</div>}
    </div>
  );
};

export default CDatePicker;
